import minuteTransformer from '@/transformers/Files/minute'
import Vue from 'vue'

/**
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 *
 * Updates a minute file
 *
 * @param  payload File and id
 * @return {Array} File's info
 */

const updateMinute = payload =>
  Vue.$http.post('catalogs/common/replace/file/', minuteTransformer.update(payload))
    .then()
    .catch((err) => {
      throw err
    })

export default updateMinute


// WEBPACK FOOTER //
// ./src/services/Files/updateMinute.js